var _excluded = ["content", "disabled", "contentPlacement", "onChange"],
  _excluded2 = ["children", "onChange", "content", "defaultSelected", "contentPlacement", "row"],
  _excluded3 = ["content", "disabled"],
  _excluded4 = ["children", "onChange", "defaultSelected"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsxs as d, jsx as i } from "react/jsx-runtime";
import { useMemo as p, Children as f, isValidElement as x, cloneElement as h } from "react";
import { css as s, styled as l } from "styled-components";
var u = function u() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  return crypto.getRandomValues(new Uint8Array(o)).reduce(function (e, r) {
    return r &= 63, r < 36 ? e += r.toString(36) : r < 62 ? e += (r - 26).toString(36).toUpperCase() : r > 62 ? e += "-" : e += "_", e;
  }, "");
};
var k = s(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    cursor: not-allowed;\n    color: ", ";\n  }\n"])), function (_ref) {
    var o = _ref.theme;
    return o.colors.black80;
  }),
  $ = l.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  ", ";\n"])), function (_ref2) {
    var o = _ref2.$contentPlacement;
    if (o === "right") return s(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        flex-direction: row;\n        && > :not(:last-child) {\n          margin-right: 8px;\n        }\n      "])));
    if (o === "left") return s(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        flex-direction: row-reverse;\n        && > :not(:last-child) {\n          margin-left: 8px;\n        }\n      "])));
    if (o === "top") return s(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        flex-direction: column-reverse;\n        && > :not(:last-child) {\n          margin-top: 8px;\n        }\n      "])));
    if (o === "bottom") return s(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        flex-direction: column;\n        && > :not(:last-child) {\n          margin-bottom: 8px;\n        }\n      "])));
  }),
  w = l.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  margin: 0;\n  ", ";\n"])), function (_ref3) {
    var o = _ref3.theme;
    return o.colors.black10;
  }, function (_ref4) {
    var o = _ref4.disabled;
    return o && k;
  }),
  C = l.input(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  && {\n    margin: 0;\n  }\n  &::after {\n    content: '';\n    display: block;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    margin: 4px;\n  }\n\n  &&:focus {\n    outline: none;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:checked::after {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border: 2px solid ", ";\n    background-color: ", ";\n  }\n\n  &:checked:hover {\n    background-color: ", ";\n    border: 2px solid ", ";\n    ::after {\n      background-color: ", ";\n    }\n  }\n  &:disabled:hover::after {\n    background-color: ", ";\n  }\n  &:disabled:checked::after {\n    background-color: ", ";\n  }\n  &:disabled:checked:hover {\n    background-color: ", ";\n    border: 2px solid ", ";\n    ::after {\n      background-color: ", ";\n    }\n  }\n"])), function (_ref5) {
    var o = _ref5.theme;
    return o.colors.blue60;
  }, function (_ref6) {
    var o = _ref6.theme;
    return o.colors.blue95;
  }, function (_ref7) {
    var o = _ref7.theme;
    return o.colors.blue60;
  }, function (_ref8) {
    var o = _ref8.theme;
    return o.colors.black80;
  }, function (_ref9) {
    var o = _ref9.theme;
    return o.colors.black100;
  }, function (_ref10) {
    var o = _ref10.theme;
    return o.colors.black100;
  }, function (_ref11) {
    var o = _ref11.theme;
    return o.colors.blue60;
  }, function (_ref12) {
    var o = _ref12.theme;
    return o.colors.blue60;
  }, function (_ref13) {
    var o = _ref13.theme;
    return o.colors.black100;
  }, function (_ref14) {
    var o = _ref14.theme;
    return o.colors.black80;
  }, function (_ref15) {
    var o = _ref15.theme;
    return o.colors.black100;
  }, function (_ref16) {
    var o = _ref16.theme;
    return o.colors.black80;
  }, function (_ref17) {
    var o = _ref17.theme;
    return o.colors.black80;
  }),
  g = function g(_ref18) {
    var o = _ref18.content,
      _ref18$disabled = _ref18.disabled,
      e = _ref18$disabled === void 0 ? !1 : _ref18$disabled,
      _ref18$contentPlaceme = _ref18.contentPlacement,
      r = _ref18$contentPlaceme === void 0 ? "right" : _ref18$contentPlaceme,
      a = _ref18.onChange,
      t = _objectWithoutProperties(_ref18, _excluded);
    var n = p(u, []);
    return /* @__PURE__ */d($, {
      $contentPlacement: r,
      children: [/* @__PURE__ */i(C, _objectSpread({
        id: n,
        type: "radio",
        role: "radio",
        disabled: e,
        onChange: a
      }, t)), o && /* @__PURE__ */i(w, {
        htmlFor: n,
        disabled: e,
        children: o
      })]
    });
  };
g.displayName = "RadioButton";
var R = l.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""]))),
  v = l.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 16px;\n  flex-direction: ", ";\n  padding-top: ", ";\n"])), function (_ref19) {
    var o = _ref19.$row;
    return o ? "row" : "column";
  }, function (_ref20) {
    var o = _ref20.$hasContent;
    return o ? "24px;" : "padding-top: 0;";
  }),
  y = l.h3(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: 'Noto Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: ", ";\n"])), function (_ref21) {
    var o = _ref21.theme;
    return o.colors.black10;
  }),
  B = function B(o, _ref22) {
    var e = _ref22.children,
      r = _ref22.onChange,
      a = _ref22.defaultSelected,
      t = _ref22.contentPlacement;
    return f.map(e, function (n) {
      if (! /*#__PURE__*/x(n) || n.type.displayName !== "RadioButton") throw new Error("RadioButtonGroup contains an unexpected child, expected RadioButton");
      var c = !!(a && a === n.props.value);
      return /*#__PURE__*/h(n, _objectSpread(_objectSpread({}, n.props), {}, {
        onChange: r,
        name: o,
        defaultChecked: c,
        contentPlacement: t
      }));
    });
  },
  T = function T(_ref23) {
    var o = _ref23.children,
      e = _ref23.onChange,
      r = _ref23.content,
      a = _ref23.defaultSelected,
      t = _ref23.contentPlacement,
      _ref23$row = _ref23.row,
      n = _ref23$row === void 0 ? !1 : _ref23$row,
      c = _objectWithoutProperties(_ref23, _excluded2);
    var b = p(u, []),
      m = B(b, {
        children: o,
        onChange: e,
        defaultSelected: a,
        contentPlacement: t
      });
    return /* @__PURE__ */d(R, _objectSpread(_objectSpread({
      role: "radiogroup"
    }, c), {}, {
      children: [r && /* @__PURE__ */i(y, {
        children: r
      }), /* @__PURE__ */i(v, {
        $hasContent: !!r,
        $row: n,
        children: m
      })]
    }));
  },
  A = s(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  && {\n    cursor: not-allowed;\n    color: ", ";\n    border-color: ", ";\n  }\n"])), function (_ref24) {
    var o = _ref24.theme;
    return o.colors.black80;
  }, function (_ref25) {
    var o = _ref25.theme;
    return o.colors.black80;
  }),
  N = l.label(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 11px 16px;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  cursor: pointer;\n\n  ", ";\n"])), function (_ref26) {
    var o = _ref26.theme;
    return o.colors.black60;
  }, function (_ref27) {
    var o = _ref27.disabled;
    return o && A;
  }),
  E = l.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin-left: 8px;\n"]))),
  G = function G(_ref28) {
    var o = _ref28.content,
      e = _ref28.disabled,
      r = _objectWithoutProperties(_ref28, _excluded3);
    return /* @__PURE__ */d(N, {
      disabled: e,
      children: [/* @__PURE__ */i(g, _objectSpread({
        contentPlacement: "right",
        disabled: e
      }, r)), /* @__PURE__ */i(E, {
        children: o
      })]
    });
  };
G.displayName = "RadioArea";
var L = l.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n"]))),
  W = function W(o, _ref29) {
    var e = _ref29.children,
      r = _ref29.onChange,
      a = _ref29.defaultSelected;
    return f.map(e, function (t) {
      if (! /*#__PURE__*/x(t) || t.type.displayName !== "RadioArea") throw new Error("RadioButtonGroup contains an unexpected child, expected RadioArea");
      var n = !!(a && a === t.props.value);
      return /*#__PURE__*/h(t, _objectSpread(_objectSpread({}, t.props), {}, {
        onChange: r,
        name: o,
        defaultChecked: n
      }));
    });
  },
  U = function U(_ref30) {
    var o = _ref30.children,
      e = _ref30.onChange,
      r = _ref30.defaultSelected,
      a = _objectWithoutProperties(_ref30, _excluded4);
    var t = p(u, []),
      n = W(t, {
        children: o,
        onChange: e,
        defaultSelected: r
      });
    return /* @__PURE__ */i(L, _objectSpread(_objectSpread({
      role: "radiogroup"
    }, a), {}, {
      children: n
    }));
  };
export { G as RadioArea, U as RadioAreaGroup, g as RadioButton, T as RadioButtonGroup };